export default [
  {
    path: '/help-center',
    name: 'PusatBantuan',
    component: () => import('@/views/pages/management-admin/help-center/Page.vue'),
    meta: {
      name: 'Pusat Bantuan',
      resource: 'Kelola User - Pusat Bantuan',
      navActiveLink: 'PusatBantuan',
      action: 'manage',
    },
  },
  {
    path: '/help-center/article/editor',
    name: 'EditorArtikel',
    component: () => import('@/views/pages/management-admin/help-center/article/editor/Page.vue'),
    meta: {
      name: 'Editor Artikel',
      resource: 'Kelola User - Pusat Bantuan',
      navActiveLink: 'PusatBantuan',
      action: 'manage',
    },
  },
]
